import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/auth/_service/auth.service';
@Injectable({ providedIn: 'root' })
export class ProductService {
	constructor(private auth: AuthService) {}

	idNeutral = environment.idNeutral;

	isNeutral(prodotto: any): boolean {
		return this.idNeutral.includes(prodotto.lineaEstetica);
	}

	filtraProdottiNeutral(prodotti: any[]): any[] {
		return prodotti.filter((p) => this.isNeutral(p));
	}

	isCategoriaCucine(prodotto: any): boolean {
		return prodotto.tipo === 'MC_P-CodLineaProdotto|05';
	}

	isCategoriaPiani(prodotto: any): boolean {
		return prodotto.tipo === 'MC_P-CodLineaProdotto|10';
	}

	isCategoriaForni(prodotto: any): boolean {
		return prodotto.tipo === 'MC_P-CodLineaProdotto|15';
	}

	isCategoriaFrigoriferi(prodotto: any): boolean {
		return prodotto.tipo === 'MC_P-CodLineaProdotto|25';
	}

	isCategoriaLavastoviglie(prodotto: any): boolean {
		return prodotto.tipo === 'MC_P-CodLineaProdotto|45';
	}

	isCategoriaCappe(prodotto: any): boolean {
		return prodotto.tipo === 'MC_P-CodLineaProdotto|80';
	}

	isSerieProfessional(lineaEstetica: any): boolean {
		return !!environment.serieCategoria[0].find((sc) => sc.serie === lineaEstetica);
	}

	isSerieMaster(lineaEstetica: any): boolean {
		return !!environment.serieCategoria[1].find((sc) => sc.serie === lineaEstetica);
	}

	isSerieHeritage(lineaEstetica: any): boolean {
		return !!environment.serieCategoria[2].find((sc) => sc.serie === lineaEstetica);
	}

	isSerieAmericana(lineaEstetica: any): boolean {
		return !!environment.serieCategoria[3].find((sc) => sc.serie === lineaEstetica);
	}

	isSerieFutura(lineaEstetica: any): boolean {
		return !!environment.serieCategoria[4].find((sc) => sc.serie === lineaEstetica);
	}

	isSeriePrima(lineaEstetica: any): boolean {
		return !!environment.serieCategoria[5].find((sc) => sc.serie === lineaEstetica);
	}

	isSerieStile(lineaEstetica: any): boolean {
		return !!environment.serieCategoria[6].find((sc) => sc.serie === lineaEstetica);
	}

	isSeriePresente(listaCodiciSerie: string): boolean {
		const prodotti = JSON.parse(sessionStorage.getItem('prodotti') || 'null');
		return !!prodotti.find((p) => listaCodiciSerie.includes(p.lineaEstetica));
	}

	isCategoriaPresente(categoria: string): boolean {
		const prodotti = JSON.parse(sessionStorage.getItem('prodotti') || 'null');
		return !!prodotti.find((p) => categoria === p.tipo);
	}

	isBrandBertazzoni(prodotto: any): boolean {
		return prodotto.marchio === 'MC_P-Cod.Marchio|FBZ';
	}

	isBrandLaGermania(prodotto: any): boolean {
		return prodotto.marchio === 'MC_P-Cod.Marchio|LAGERMANIA';
	}

	isSerieBertazzoni(lineaEstetica) {
		return this.isSerieProfessional(lineaEstetica) || this.isSerieMaster(lineaEstetica) || this.isSerieHeritage(lineaEstetica);
	}

	isSerieLaGermania(lineaEstetica) {
		return (
			this.isSerieAmericana(lineaEstetica) ||
			this.isSerieFutura(lineaEstetica) ||
			this.isSerieStile(lineaEstetica) ||
			this.isSeriePrima(lineaEstetica)
		);
	}

	calcolaGiacenzaMagazzino(prodottoCommerciale: any): number {
		if (!prodottoCommerciale?.magazzini || prodottoCommerciale.magazzini.length === 0) {
			return 0;
		}

		if (this.auth.getUser()?.company?.codice === 'USS00') {
			const magazzino = prodottoCommerciale.magazzini.find((m: any) => m.magazzino.nome === 'USS00');
			return magazzino ? magazzino.giacenza : 0;
		}
		return prodottoCommerciale.magazzini.reduce((acc: number, magazzino: any) => acc + magazzino.giacenza, 0);
	}

	condizioneCopiaNeutral(prodotto, lineaEstetica): boolean {
		// Non copio se la serie non appartiene al brand
		if (this.isBrandBertazzoni(prodotto) && !this.isSerieBertazzoni(lineaEstetica)) {
			return false;
		}
		if (this.isBrandLaGermania(prodotto) && !this.isSerieLaGermania(lineaEstetica)) {
			return false;
		}

		// Regola per i prodotti bertazzoni --> copio in tutte e 3 tranne per cappe piani e forni che non vanno in heritage
		if (this.isBrandBertazzoni(prodotto)) {
			return !(
				(this.isCategoriaCappe(prodotto) || this.isCategoriaForni(prodotto) || this.isCategoriaPiani(prodotto)) &&
				this.isSerieHeritage(prodotto.lineaEstetica)
			);

			// Regola per i prodotti la germania --> cappe piani forni e lavastovieglie in futura, le cappe anche in americana
		} else {
			return (
				(this.isSerieFutura(lineaEstetica) &&
					(this.isCategoriaCappe(prodotto) ||
						this.isCategoriaPiani(prodotto) ||
						this.isCategoriaForni(prodotto) ||
						this.isCategoriaLavastoviglie(prodotto))) ||
				(this.isSerieAmericana(lineaEstetica) && this.isCategoriaCappe(prodotto))
			);
		}
	}
}
